var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalSalesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vuesax_bold_graph",
    "data-name": "vuesax/bold/graph",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.15,
    height: 57.15,
    viewBox: "0 0 57.15 57.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_graph-2",
    "data-name": "vuesax/bold/graph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.051,11.786a16.626,16.626,0,0,0-11-11C7.12-.359,4.405-.263,2.524,1.142.262,2.832,0,5.88,0,8.047v5.929c0,5.858,2.667,8.834,7.906,8.834H14.74c2.143,0,5.215-.262,6.906-2.524C23.1,18.43,23.217,15.715,22.051,11.786Z",
    transform: "translate(29.552 4.764)",
    fill: "#2a4c7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M40.261,20.505a3.258,3.258,0,0,0-2.453-1.119H29.284a7.6,7.6,0,0,1-7.6-7.6V3.265A3.258,3.258,0,0,0,20.568.812,3.228,3.228,0,0,0,18.02.026a20.8,20.8,0,0,0-14.1,8.406A20.557,20.557,0,0,0,16.687,40.7a19.972,19.972,0,0,0,3.929.381A20.237,20.237,0,0,0,32.641,37.15a20.8,20.8,0,0,0,8.406-14.1A3.2,3.2,0,0,0,40.261,20.505Z",
    transform: "translate(4.769 11.308)",
    fill: "#2a4c7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H57.15V57.15H0Z",
    transform: "translate(57.15 57.15) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSalesIcon);
export default __webpack_public_path__ + "static/media/TotalSalesIcon.a3ae317ded4533269a40fe996ab06511.svg";
export { ForwardRef as ReactComponent };